<template>
  <div>
    <v-skeleton-loader v-if="$apollo.loading" type="list-item-two-line" class="text-left" />
    <div v-else>
      <v-card v-if="taskComments.length > 0" elevation="0" class="ma-0 pa-0 overflow-auto">
        <div v-for="comment in taskComments" :key="comment.node.id" class="my-2 d-flex">
          <user-avatar
            :profile-picture="comment.node.user.userProfile.profilePicture"
            :user="comment.node.user"
            size="30"
          />
          <v-card class="alert-grey-background mx-2 pt-2 mt-0 mb-2 flex-grow-1 pl-2" rounded="lg">
            <div class="block d-flex justify-space-between">
              <b>
                <span class="navy--text">{{ comment.node.user.firstName }} {{ comment.node.user.lastName }}</span>
              </b>
              <div class="sm-text navy--text pb-2">{{ fancyShortDate(comment.node.createdAt) }}</div>
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small icon v-bind="attrs" v-on="on">
                    <v-icon small>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-if="comment.node.user.id == $store.getters.user.id"
                    link
                    @click="deleteComment(comment.node.id)"
                  >
                    <v-list-item-title class="p-text">Delete Comment</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <span class="p-text d-flex justify-start pb-2 text-left">{{ comment.node.text }}</span>
          </v-card>
        </div>
      </v-card>
      <div v-else class="grey--text text--darken-2 font-italic text-right">
        <span>
          No comments to display
        </span>
      </div>
    </div>
    <div class="d-flex justify-space-between mt-2">
      <v-textarea
        v-model="commentText"
        :disabled="saving"
        placeholder="Add a comment (Cmd/Ctrl + Enter to save)"
        auto-grow
        outlined
        dense
        rows="1"
        row-height="15"
        @keydown.enter.ctrl.exact="postComment()"
        @keydown.enter.meta.exact="postComment()"
      />
      <v-btn
        v-if="commentText"
        tertiary
        small
        narrow
        secondary
        @click="postComment()"
        color="jeff-life"
        class="mt-2 mx-3 px-2 font-weight-bold"
        dark
      >
        Comment
      </v-btn>
    </div>
  </div>

</template>

<script>
import { CREATE_TASK_COMMENT_MUTATION, DELETE_TASK_COMMENT_MUTATION } from "@/graphql/mutations/task";
import { TASK_COMMENTS_QUERY } from "@/graphql/queries/task";
import { decodeId } from "@/lib/string";
import UserAvatar from "@/components/shared/user/UserAvatar";
import { fancyShortDate } from "@/lib/fancy_date";

export default {
  name: "TaskComment",
  props: {
    taskId: {
      type: String,
      required: true,
    },
  },
  components: {
    UserAvatar,
  },
  data() {
    return {
      commentText: null,
      saving: false,
      taskComments: [],
    };
  },
  methods: {
    getId(idString) {
      return decodeId(idString);
    },
    fancyShortDate(date) {
      return fancyShortDate(date);
    },
    async postComment() {
      this.saving = true;
      await this.$apollo.mutate({
        mutation: CREATE_TASK_COMMENT_MUTATION,
        variables: {
          text: this.commentText,
          taskId: this.getId(this.taskId),
        },
      });

      await this.$apollo.queries.taskComments.refetch();

      this.saving = false;
      this.commentText = null;
    },
    async deleteComment(id) {
      this.saving = true;
      await this.$apollo.mutate({
        mutation: DELETE_TASK_COMMENT_MUTATION,
        variables: {
          id: this.getId(id),
        },
      });

      await this.$apollo.queries.taskComments.refetch();
      this.saving = false;
    },
  },
  apollo: {
    taskComments: {
      query: TASK_COMMENTS_QUERY,
      variables() {
        return {
          taskId: this.taskId,
        };
      },
      // network-only, otherwise doesn't update the listing card nicely on update
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
      update: (data) => data.taskComments.edges,
    },
  },
};
</script>
